// Used for UUIDs validation
export const UUID_REGEX = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
// Used for phone number validation
export const PHONE_REGEX = /^380\d{9}$/;
